module.exports = __webpack_public_path__ + "img/QuietComfortProTitle.88af7a47.svg";